// extracted by mini-css-extract-plugin
export default {"button":"OutlineActionButton_button__tMjd5","icon":"OutlineActionButton_icon__DfEkc","iconSpin":"OutlineActionButton_iconSpin__bQozN","spin":"OutlineActionButton_spin__+YC5Z"};